import React from 'react'
import { SvgIcon, SvgIconProps } from '@mui/material'

const FeedbackIconSvg = (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M4.5 6.75A2.25 2.25 0 0 1 6.75 4.5h10.5a2.25 2.25 0 0 1 2.25 2.25v7.5a2.25 2.25 0 0 1-2.25 2.25H9.6l-3.9 3.3a.45.45 0 0 1-.75-.35V6.75Z" />
            <path d="M8.5 9.25h7M8.5 12.5h4.5" />
        </g>
    </svg>
)

const FeedbackIcon: React.FC<SvgIconProps> = (props) => (
    <SvgIcon {...props}>
        {FeedbackIconSvg}
    </SvgIcon>
)

export default FeedbackIcon
